import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=66f977e2&scoped=true"
var script = {}
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=66f977e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f977e2",
  null
  
)

export default component.exports